export default {
    props: {
      showDialog: Boolean,
    },
    computed: {
      visible: {
        get() {
          return this.showDialog;
        },
        set(val) {
          this.$emit('update:showDialog', val);
        },
      },
    },
    methods: {
      closeDialog() {
        this.visible = false;
      },
    },
  };
  